import { __extends, __values } from "tslib";
import * as React from 'react';
import { delegateCombine, delegateRemove } from "igniteui-react-core";
import { ButtonBaseType_$type } from "./ButtonBaseType";
import { ButtonBaseTarget_$type } from "./ButtonBaseTarget";
import { IgrVoidEventArgs } from "./igr-void-event-args";
import { TypeRegistrar } from "igniteui-react-core";
import { ReactRenderer, PortalManager } from "igniteui-react-core";
import { NamePatcher, getModifiedProps, isValidProp, ensureEnum, ensureBool, toSpinal, initializePropertiesFromCss } from "igniteui-react-core";
var IgrButtonBase = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrButtonBase, _super);
    function IgrButtonBase(props) {
        var _this = _super.call(this, props) || this;
        _this.mounted = false;
        _this.__p = null;
        _this._hasUserValues = new Set();
        _this._stylingContainer = null;
        _this._stylingParent = null;
        _this._inStyling = false;
        _this._clicked = null;
        _this._clicked_wrapped = null;
        _this._focus = null;
        _this._focus_wrapped = null;
        _this._blur = null;
        _this._blur_wrapped = null;
        if (_this._styling) {
            NamePatcher.ensureStylablePatched(Object.getPrototypeOf(_this));
        }
        _this._implementation = _this.createImplementation();
        _this._portalManager = new PortalManager("templates", function () {
            if (_this.mounted) {
                _this.setState({});
            }
        });
        if (typeof window !== 'undefined' && typeof document !== 'undefined') {
            _this._renderer = new ReactRenderer(_this._implementation.nativeElement, document, false, null, _this._portalManager);
        }
        _this._implementation.externalObject = _this;
        _this.onImplementationCreated();
        if (_this._initializeAdapters) {
            _this._initializeAdapters();
        }
        return _this;
    }
    IgrButtonBase.prototype.createImplementation = function () {
        return null;
    };
    Object.defineProperty(IgrButtonBase.prototype, "nativeElement", {
        get: function () {
            return this._implementation.nativeElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrButtonBase.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        } /**
                                     * @hidden
                                     */,
        enumerable: false,
        configurable: true
    });
    IgrButtonBase._createFromInternal = function (internal) {
        if (!internal) {
            return null;
        }
        if (!internal.$type) {
            return null;
        }
        var name = internal.$type.name;
        var externalName = "Igr" + name;
        if (!TypeRegistrar.isRegistered(externalName)) {
            return null;
        }
        return TypeRegistrar.create(externalName);
    };
    IgrButtonBase.prototype.onImplementationCreated = function () {
    };
    IgrButtonBase.prototype.componentDidMount = function () {
        var e_1, _a;
        this.mounted = true;
        try {
            for (var _b = __values(Object.keys(this.props)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var p = _c.value;
                if (isValidProp(this, p)) {
                    this[p] = this.props[p];
                }
            }
        }
        catch (e_1_1) {
            e_1 = { error: e_1_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_1)
                    throw e_1.error;
            }
        }
    };
    IgrButtonBase.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var e_2, _a;
        var mod = getModifiedProps(this.props, nextProps);
        try {
            for (var _b = __values(Object.keys(mod)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var p = _c.value;
                if (isValidProp(this, p)) {
                    this[p] = mod[p];
                }
            }
        }
        catch (e_2_1) {
            e_2 = { error: e_2_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_2)
                    throw e_2.error;
            }
        }
        return true;
    };
    IgrButtonBase.prototype.render = function () {
        return null;
    };
    Object.defineProperty(IgrButtonBase.prototype, "type", {
        /**
         * The type of the button. Defaults to `button`.
        */
        get: function () {
            return this.i.b;
        },
        set: function (v) {
            this.i.b = ensureEnum(ButtonBaseType_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrButtonBase.prototype, "href", {
        /**
         * The URL the button points to.
        */
        get: function () {
            return this.i.m;
        },
        set: function (v) {
            this.i.m = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrButtonBase.prototype, "download", {
        /**
         * Prompts to save the linked URL instead of navigating to it.
        */
        get: function () {
            return this.i.l;
        },
        set: function (v) {
            this.i.l = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrButtonBase.prototype, "target", {
        /**
         * Where to display the linked URL, as the name for a browsing context.
        */
        get: function () {
            return this.i.a;
        },
        set: function (v) {
            this.i.a = ensureEnum(ButtonBaseTarget_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrButtonBase.prototype, "rel", {
        /**
         * The relationship of the linked URL.
         * See https://developer.mozilla.org/en-US/docs/Web/HTML/Link_types
        */
        get: function () {
            return this.i.n;
        },
        set: function (v) {
            this.i.n = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrButtonBase.prototype, "disabled", {
        get: function () {
            return this.i.h;
        },
        set: function (v) {
            this.i.h = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrButtonBase.prototype, "form", {
        /**
         * Returns the HTMLFormElement associated with this element.
        */
        get: function () {
            return this.i.j;
        },
        enumerable: false,
        configurable: true
    });
    IgrButtonBase.prototype.findByName = function (name) {
        if (this.findEphemera) {
            if (name && name.indexOf("@@e:") == 0) {
                return this.findEphemera(name);
            }
        }
        return null;
    };
    Object.defineProperty(IgrButtonBase.prototype, "hasUserValues", {
        get: function () {
            return this._hasUserValues;
        },
        enumerable: false,
        configurable: true
    });
    IgrButtonBase.prototype.__m = function (propertyName) {
        if (!this._inStyling) {
            this._hasUserValues.add(propertyName);
        }
    };
    IgrButtonBase.prototype._styling = function (container, component, parent) {
        if (this._inStyling) {
            return;
        }
        this._inStyling = true;
        this._stylingContainer = container;
        this._stylingParent = component;
        var genericPrefix = "";
        var typeName = this.i.$type.name;
        if (typeName.indexOf("Xam") === 0) {
            typeName = typeName.substring(3);
        }
        genericPrefix = toSpinal("ButtonBase");
        var additionalPrefixes = [];
        var prefix = toSpinal(typeName);
        additionalPrefixes.push(prefix + "-");
        var b = this.i.$type.baseType;
        while (b && b.name != "Object" &&
            b.name != "Base" &&
            b.name != "Control" &&
            b.Name != "DependencyObject" &&
            b.Name != "FrameworkElement") {
            typeName = b.name;
            if (typeName.indexOf("Xam") === 0) {
                typeName = typeName.substring(3);
            }
            var basePrefix = toSpinal(typeName);
            additionalPrefixes.push(basePrefix + "-");
            b = b.baseType;
        }
        if (parent) {
            var parentTypeName = parent.i.$type.name;
            if (parentTypeName.indexOf("Xam") === 0) {
                parentTypeName = parentTypeName.substring(3);
            }
            var parentPrefix = toSpinal(parentTypeName);
            additionalPrefixes.push(parentPrefix + "-" + genericPrefix + "-");
            additionalPrefixes.push(parentPrefix + "-" + prefix + "-");
        }
        initializePropertiesFromCss(container, this, genericPrefix + "-", this.hasUserValues, false, additionalPrefixes);
        if (this._otherStyling) {
            this._otherStyling(container, component, parent);
        }
        this._inStyling = false;
    };
    IgrButtonBase.prototype.setNativeElement = function (element) {
        this.i.setNativeElement(element);
    };
    /**
     * Sets focus in the button.
    
    */
    IgrButtonBase.prototype.focusComponent = function (options) {
        this.i.t((options == null ? null : options.i));
    };
    /**
     * Simulates a mouse click on the element
    
    */
    IgrButtonBase.prototype.click = function () {
        this.i.q();
    };
    /**
     * Removes focus from the button.
    
    */
    IgrButtonBase.prototype.blurComponent = function () {
        this.i.p();
    };
    Object.defineProperty(IgrButtonBase.prototype, "clicked", {
        get: function () {
            return this._clicked;
        },
        set: function (ev) {
            var _this = this;
            if (this._clicked_wrapped !== null) {
                this.i.clicked = delegateRemove(this.i.clicked, this._clicked_wrapped);
                this._clicked_wrapped = null;
                this._clicked = null;
            }
            this._clicked = ev;
            this._clicked_wrapped = function (o, e) {
                var outerArgs = new IgrVoidEventArgs();
                outerArgs._provideImplementation(e);
                if (_this.beforeClicked) {
                    _this.beforeClicked(_this, outerArgs);
                }
                if (_this._clicked) {
                    _this._clicked(_this, outerArgs);
                }
            };
            this.i.clicked = delegateCombine(this.i.clicked, this._clicked_wrapped);
            if (this.i.clickedChanged) {
                this.i.clickedChanged();
            }
            ;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrButtonBase.prototype, "focus", {
        get: function () {
            return this._focus;
        },
        set: function (ev) {
            var _this = this;
            if (this._focus_wrapped !== null) {
                this.i.focus = delegateRemove(this.i.focus, this._focus_wrapped);
                this._focus_wrapped = null;
                this._focus = null;
            }
            this._focus = ev;
            this._focus_wrapped = function (o, e) {
                var outerArgs = new IgrVoidEventArgs();
                outerArgs._provideImplementation(e);
                if (_this.beforeFocus) {
                    _this.beforeFocus(_this, outerArgs);
                }
                if (_this._focus) {
                    _this._focus(_this, outerArgs);
                }
            };
            this.i.focus = delegateCombine(this.i.focus, this._focus_wrapped);
            if (this.i.focusChanged) {
                this.i.focusChanged();
            }
            ;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrButtonBase.prototype, "blur", {
        get: function () {
            return this._blur;
        },
        set: function (ev) {
            var _this = this;
            if (this._blur_wrapped !== null) {
                this.i.blur = delegateRemove(this.i.blur, this._blur_wrapped);
                this._blur_wrapped = null;
                this._blur = null;
            }
            this._blur = ev;
            this._blur_wrapped = function (o, e) {
                var outerArgs = new IgrVoidEventArgs();
                outerArgs._provideImplementation(e);
                if (_this.beforeBlur) {
                    _this.beforeBlur(_this, outerArgs);
                }
                if (_this._blur) {
                    _this._blur(_this, outerArgs);
                }
            };
            this.i.blur = delegateCombine(this.i.blur, this._blur_wrapped);
            if (this.i.blurChanged) {
                this.i.blurChanged();
            }
            ;
        },
        enumerable: false,
        configurable: true
    });
    return IgrButtonBase;
}(React.Component));
export { IgrButtonBase };
